/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Utils
import { isEmpty, isObject } from 'lodash';

// Components
import HtmlEditor from 'shared/ui/components/editors/html/HtmlEditor.vue';
import LocaleSelector from 'shared/ui/components/form-components/pickers/LocaleSelector.vue';

const __vue_script__ = {
    name: 'EditorialContent',

    components: { HtmlEditor, LocaleSelector },

    props: {
        event: {
            type: Object,
            default: () => ({})
        },

        saveCallback: {
            type: Function,
            required: true
        },

        label: {
            type: String,
            default: null
        },

        value: {
            type: [String, Object],
            default: null
        },

        allowEmptyValue: {
            type: Boolean,
            default: true
        }
    },

    data() {
        const languageList = this.event?.languages || [];
        const defaultLang = languageList[0] || 'en';
        const isT9nEnabled = languageList.length > 1;
        const editing = this.value !== null;

        let modalTitle = 'registration.configuration.form.description';
        let saveButtonCaption = 'general.save';

        if (!isT9nEnabled) {
            if (!editing) {
                modalTitle = 'registration.configuration.form.add_description';
                saveButtonCaption = 'general.add';
            } else {
                modalTitle = 'registration.configuration.form.edit_description';
            }
        }

        return {
            html: '',
            displayLabels: { [defaultLang]: this.label || this.$t('general.forms.labels.description') },
            isT9nEnabled,
            currentLang: this.event.languages?.[0] || 'en',
            editing,
            languageList,
            showEmptyTextError: false,
            defaultLang,
            text: '',
            saveButtonCaption,
            modalTitle,
        };
    },

    watch: {
        currentLang: {
            immediate: true,
            handler() {
                this.updateValues();
            }
        },
        value: {
            handler() {
                this.initializeFromValue();
            },
            deep: true
        }
    },

    created() {
        this.initializeFromValue();
    },

    methods: {
        updateValues() {
            if (this.isT9nEnabled) {
                this.html = (this.text && this.text[this.currentLang]) || '';
            } else {
                this.html = this.text || '';
            }
        },

        initializeFromValue() {
            if (this.isT9nEnabled) {
                if (isObject(this.value)) {
                    this.text = {};
                    for (const lang of this.languageList) {
                        if (this.value.hasOwnProperty(lang)) {
                            this.text[lang] = this.value[lang];
                        }
                    }
                } else if (typeof this.value === 'string') {
                    this.text = { [this.defaultLang]: this.value };
                } else {
                    this.text = {};
                }
                this.html = this.text[this.currentLang] || '';
            } else {
                this.text = this.value || '';
                this.html = this.text;
            }
        },

        save() {
            if (!this.allowEmptyValue) {
                let isEmptyState = true;

                if (this.isT9nEnabled) {
                    for (const lang of this.languageList) {
                        if (this.text[lang]) {
                            isEmptyState = false;
                        }
                    }
                } else {
                    isEmptyState = isEmpty(this.text);
                }

                if (isEmptyState) {
                    this.showEmptyTextError = true;
                    return;
                }

            }

            this.saveCallback({
                type: 'text',
                text: this.text,
                removable: true,
                label: this.getDisplayLabel()
            });

            if (!this.isT9nEnabled) {
                this.$emit('close');
            }

            this.showEmptyTextError = false;
        },

        updateText(html, lang = this.currentLang) {
            this.displayLabels[lang] = this.$refs.html?.getText();

            if (this.isT9nEnabled) {
                this.text = { ...this.text, [lang]: html };
            } else {
                this.text = html;
            }
        },

        getDisplayLabel() {
            let label = this.displayLabels[this.defaultLang] || this.$t('general.forms.labels.description');
            return label.trim();
        }
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "editorial-content modal-wrapper" }, [
    _c("div", { staticClass: "modal-header" }, [
      _c("a", {
        staticClass: "close",
        attrs: { href: "#", "aria-label": _vm.$t("general.close") },
        on: {
          click: function ($event) {
            $event.preventDefault()
            return _vm.$emit("close")
          },
        },
      }),
      _c("h2", [_vm._v(_vm._s(_vm.$t(_vm.modalTitle)))]),
    ]),
    _c(
      "div",
      { staticClass: "modal-body" },
      [
        _vm.showEmptyTextError
          ? _c("div", { staticClass: "alert alert-danger" }, [
              _vm._v(_vm._s(_vm.$t("validations.no_empty_field"))),
            ])
          : _vm._e(),
        _vm.isT9nEnabled
          ? _c("locale-selector", {
              attrs: {
                event: _vm.event,
                label: _vm.$t("general.forms.labels.locale"),
              },
              model: {
                value: _vm.currentLang,
                callback: function ($$v) {
                  _vm.currentLang = $$v
                },
                expression: "currentLang",
              },
            })
          : _vm._e(),
        _c("html-editor", {
          ref: "html",
          attrs: {
            name: "description",
            "event-id": _vm.event._id,
            links: true,
            "enable-custom-bstg-links": false,
            extras: false,
            images: true,
          },
          on: { input: _vm.updateText },
          model: {
            value: _vm.html,
            callback: function ($$v) {
              _vm.html = $$v
            },
            expression: "html",
          },
        }),
      ],
      1
    ),
    _c("div", { staticClass: "modal-footer" }, [
      _c("footer", { staticClass: "actions" }, [
        _c(
          "button",
          {
            staticClass: "btn",
            on: {
              click: function ($event) {
                return _vm.$emit("close")
              },
            },
          },
          [_vm._v(_vm._s(_vm.$t("general.close")))]
        ),
        _c(
          "button",
          {
            staticClass: "btn btn-primary",
            on: {
              click: function ($event) {
                return _vm.save()
              },
            },
          },
          [_vm._v(_vm._s(_vm.$t(_vm.saveButtonCaption)))]
        ),
      ]),
    ]),
  ])
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/shared/src/ui/components/form-components/registrations/EditorialContent.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__